var _excluded = ["children", "routing"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { safelyRunOnBrowser } from "instantsearch.js/es/lib/utils/index.js";
import { headers } from "next/headers.js";
import React, { useEffect, useMemo, useRef } from 'react';
import { InstantSearch, InstantSearchRSCContext, InstantSearchSSRProvider } from 'react-instantsearch-core';
import { InitializePromise } from "./InitializePromise.js";
import { TriggerSearch } from "./TriggerSearch.js";
import { useInstantSearchRouting } from "./useInstantSearchRouting.js";
import { warn } from "./warn.js";
var InstantSearchInitialResults = Symbol.for('InstantSearchInitialResults');
var _ref2 = /*#__PURE__*/React.createElement(TriggerSearch, null);
export function InstantSearchNext(_ref) {
  var children = _ref.children,
    passedRouting = _ref.routing,
    instantSearchProps = _objectWithoutProperties(_ref, _excluded);
  var isMounting = useRef(true);
  var isServer = typeof window === 'undefined';
  var hasRouteChanged = useMemo(function () {
    // On server, always return false
    if (isServer) {
      return false;
    }

    // On client, route has changed if initialResults have been cleaned up
    var hasInitialResults = window[InstantSearchInitialResults] !== undefined;
    return !hasInitialResults;
  }, [isServer]);

  // We only want to trigger a search from a server environment
  // or if a Next.js route change has happened on the client
  var shouldTriggerSearch = isServer || hasRouteChanged;
  useEffect(function () {
    isMounting.current = false;
    return function () {
      // This is to make sure that they're not reused if mounting again on a different route
      delete window[InstantSearchInitialResults];
    };
  }, []);
  var nonce = safelyRunOnBrowser(function () {
    return undefined;
  }, {
    fallback: function fallback() {
      return headers().get('x-nonce') || undefined;
    }
  });
  var routing = useInstantSearchRouting(passedRouting, isMounting);
  var promiseRef = useRef(null);
  var initialResults = safelyRunOnBrowser(function () {
    return window[InstantSearchInitialResults];
  });
  process.env.NODE_ENV === 'development' ? warn(false, "InstantSearchNext relies on experimental APIs and may break in the future.\nThis message will only be displayed in development mode.") : void 0;
  return /*#__PURE__*/React.createElement(InstantSearchRSCContext.Provider, {
    value: promiseRef
  }, /*#__PURE__*/React.createElement(InstantSearchSSRProvider, {
    initialResults: initialResults
  }, /*#__PURE__*/React.createElement(InstantSearch, _extends({}, instantSearchProps, {
    routing: routing
  }), shouldTriggerSearch && /*#__PURE__*/React.createElement(InitializePromise, {
    nonce: nonce
  }), children, shouldTriggerSearch && _ref2)));
}